import { render, staticRenderFns } from "./NotificationListCatalog.vue?vue&type=template&id=d5b17fa4&scoped=true"
import script from "./NotificationListCatalog.vue?vue&type=script&lang=js"
export * from "./NotificationListCatalog.vue?vue&type=script&lang=js"
import style0 from "./NotificationListCatalog.vue?vue&type=style&index=0&id=d5b17fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b17fa4",
  null
  
)

export default component.exports